
import { createSelector } from 'reselect';

export const quantitySelector = createSelector(
    state => state.quantity,
    quantity => quantity,
);
